import { defineStyleConfig, defineStyle } from '@chakra-ui/react';

const main = defineStyle({
  color: 'rentals.primary.txt',
});

const Text = defineStyleConfig({
  variants: { main },
  defaultProps: { variant: 'main' },
});

export default Text;
